/**
 * 订单导入
 * @author lixian
 */
export default {
  BASE_URL: '/tmb/order',
  api: [
    {
      name: 'import',
      desc: '订单导入',
      method: 'GET',
      path: 'import'
    },
    {
      name: 'template',
      desc: '订单模板下载',
      method: 'GET',
      path: 'import/template'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/imp.js